export default __webpack_public_path__ + "static/Edmondsans-Regular-65ab4efcdea03f7c36f5f64c95963538.otf";